import React from 'react';
import { Route } from 'react-router-dom';
import { BasicDashboard } from './dashboards/BasicDashboard';
import { DashboardWrapper } from './dashboards/DashboardWrapper';

export const customRoutes = [
    <Route exact path="/basic-dashboard" component={BasicDashboard} />,
    <Route path='/dashboard/:dashboardId' component={DashboardWrapper}/>,
];
